import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { buttonToComponentMapping } from 'search-new/containers/FilterableListView/ActionButtons'
import { selectActiveActionButton } from 'shared/search/selectors'
import { setActiveActionButton, triggerDataRefresh } from 'shared/search/action-creators'

const mapStateToProps = (state, props) => ({
    activeActionButtonId: selectActiveActionButton(state, props),
})

const actions = { setActiveActionButton, triggerDataRefresh }

export class ListViewDisplayWrapper extends Component {
    static propTypes = {
        // from flv
        uniqueFlvId: PropTypes.string.isRequired,
        quorumDataType: PropTypes.number.isRequired,
        resource: PropTypes.object.isRequired,
        bulkActionsConsole: PropTypes.func,
        visualizationConsole: PropTypes.func,
        // from connect
        activeActionButtonId: PropTypes.string,
        clearAndCloseDisplay: PropTypes.func,
        triggerDataRefresh: PropTypes.func,
    }

    constructor(props) {
        super(props)

        this.clearAndCloseDisplay = this.clearAndCloseDisplay.bind(this)
        this.triggerDataRefresh = this.triggerDataRefresh.bind(this)
    }

    renderDefault() {
        return (
            <div
                id="advanced-search-trends"
                className="row advanced-search-visualization"
            >
                {this.props.activeActionButtonId}
            </div>
        )
    }

    clearAndCloseDisplay() {
        this.props.setActiveActionButton(this.props.uniqueFlvId, undefined)
    }

    triggerDataRefresh() {
        this.props.triggerDataRefresh(this.props.uniqueFlvId, this.props.resource)
    }

    render() {
        const DisplayComponent = buttonToComponentMapping[this.props.activeActionButtonId]
        return DisplayComponent
            ? <DisplayComponent
                uniqueFlvId={this.props.uniqueFlvId}
                quorumDataType={this.props.quorumDataType}
                resource={this.props.resource}
                onSuccessHide={this.clearAndCloseDisplay} // used in the event of completing an action (forms)
                triggerDataRefresh={this.triggerDataRefresh} // used in the event of posting an object, forcing list view refresh (forms)
                bulkActionsConsole={this.props.bulkActionsConsole}
                // used in visualization console, because there must be one "Visualization Console Wrapper"
                // to rule them all (aka the thing that renders when the visualization button is clicked)
                // and then we need to render our specific console within the wrapper.
                visualizationConsole={this.props.visualizationConsole}
            />
            : this.renderDefault()
    }
}

export default connect(mapStateToProps, actions)(ListViewDisplayWrapper)
